import type { QuestionnaireState } from "../../../types";

export const handleSetVisibleAction = (
  state: QuestionnaireState,
  payload: string[], // questionNames
): QuestionnaireState => {
  const visibilityMap = { ...state.visibility };

  payload.forEach(questionName => {
    visibilityMap[questionName] = true;
  });

  return {
    ...state,
    visibility: visibilityMap,
  };
};

export const handleSetHiddenAction = (
  state: QuestionnaireState,
  payload: string[], // questionNames
): QuestionnaireState => {
  const visibilityMap = { ...state.visibility };

  payload.forEach(questionName => {
    visibilityMap[questionName] = false;
  });

  return {
    ...state,
    visibility: visibilityMap,
  };
};
